"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var relay_runtime_1 = require("relay-runtime");
function fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    if (!environment.isRehydrated()) {
        return environment.hydrate().then(function () {
            return relay_runtime_1.fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig);
        });
    }
    return relay_runtime_1.fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig);
}
exports.fetchQuery_DEPRECATED = fetchQuery_DEPRECATED;
//# sourceMappingURL=fetchQuery_DEPRECATED.js.map